import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { LeadActionTypes, LeadActions } from "../../../actionTypes/sales/leadActionTypes";
import {
  createLeadApi,
  deleteSalesLeadApi,
  editLeadDataByIdApi,
  getLeadDataByIdApi,
  getLeadListApi,
  getMyLeadDataByIdApi,
  getMyLeadListApi,
} from "../../requests/sales/leadRequests";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import { getLeadList, setLeadDataById, setLeadList, setLeadListPageCount, setMyLeadDataById, setMyLeadList, setMyLeadListPageCount } from "../../../actions/sales/leadActions";


function* createLeadHandler(action: LeadActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createLeadApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getLeadListHandler(action: LeadActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getLeadListApi, action.payload);

    if (data.status) {
      yield put(setLeadList(data?.data?.rows));
      yield put(setLeadListPageCount(Math.ceil(data?.data?.count / action.payload.pageLimit) || 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getMyLeadListHandler(action: LeadActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getMyLeadListApi, action.payload);

    if (data.status) {
      yield put(setMyLeadList(data?.data?.rows));
      yield put(setMyLeadListPageCount(Math.ceil(data?.data?.count / action.payload.pageLimit) || 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getLeadDataByIdHandler(action: LeadActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getLeadDataByIdApi, action.payload);
    if (data.status) {
      yield put(setLeadDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getmyLeadDataByIdHandler(action: LeadActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getMyLeadDataByIdApi, action.payload);
    if (data.status) {
      yield put(setMyLeadDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editLeadDataByIdHandler(action: LeadActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editLeadDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getLeadList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* deleteSalesLeadHandler(action: LeadActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(deleteSalesLeadApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(getLeadList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

// lead sagas
export default function* leadSaga() {
  yield takeLatest(LeadActions.CREATE_LEAD, createLeadHandler);
  yield takeLatest(LeadActions.GET_LEAD_LIST, getLeadListHandler);
  yield takeLatest(LeadActions.GET_MY_LEAD_LIST, getMyLeadListHandler);
  yield takeLatest(LeadActions.GET_LEAD_DATA_BY_ID, getLeadDataByIdHandler);
  yield takeLatest(LeadActions.GET_MY_LEAD_DATA_BY_ID, getmyLeadDataByIdHandler);
  yield takeLatest(LeadActions.EDIT_LEAD_DATA_BY_ID, editLeadDataByIdHandler);
  yield takeLatest(LeadActions.DELETE_LEAD, deleteSalesLeadHandler);
}
